import {AsiDialogView} from "@asi-ngtools/lib";
import {Component} from "@angular/core";

@Component({
    selector: 'waiting-modal',
    templateUrl: './waiting.modal.html',
})
export class WaitingModal extends AsiDialogView {

    titre: string = "MODAL.chargement";

    constructor() {
        super();
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/modal/waiting/waiting.modal.ts